import React, { Component, ErrorInfo, PropsWithChildren } from 'react';
import * as Sentry from '@sentry/browser';

import { TooLazyToType } from 'types/TooLazyToType';
import ErrorState from 'components/ErrorState';

type Props = PropsWithChildren<{
  getAccountError: TooLazyToType | undefined;
  getProfileError: TooLazyToType | undefined;
}>;

export class ErrorBoundary extends Component<
  Props,
  { javascriptError: Error | undefined }
> {
  constructor(props: Props) {
    super(props);
    this.state = { javascriptError: undefined };
  }

  static getDerivedStateFromError(error: Error) {
    return {
      javascriptError: {
        ...error,
        // adding these explicitly to fix test behaviour
        name: error.name,
        message: error.message,
      },
    };
  }

  componentDidCatch(error: Error, errorInfo: ErrorInfo) {
    Sentry.withScope(scope => {
      scope.setExtra('reactErrorInfo', errorInfo);
      Sentry.captureException(error);
    });
  }

  render() {
    const { javascriptError } = this.state;
    const { getAccountError, getProfileError } = this.props;
    if (javascriptError || getAccountError || getProfileError) {
      return (
        <ErrorState
          javascriptError={javascriptError}
          getAccountError={getAccountError}
          getProfileError={getProfileError}
        />
      );
    }
    const { children } = this.props;
    return children;
  }
}
